import Cookies from "universal-cookie";
// import axios from "axios";
// import { JWT_COOKIE_NAME, AUTH_REDIRECT } from "../constants";
// import React from "react";
import { certificationPage, createCurrentUrl } from "./registrationUtils";
import {getPageFromUrl} from "../components/utils/getPageFromUrl";
const cookies = new Cookies();

export const gaEvent = (customEvent, category, label, value) => {
  if (window !== undefined && window?.dataLayer !== undefined) {
    window?.dataLayer?.push({
      event: customEvent,
      eventCategory: category,
      eventLabel: label,
      eventValue: value
    });
  }
};

export const gaDataLayer = (
  contentType,
  pageType,
  domainId,
  verticalName,
  entityID,
  authorUid,
  authorName,
  entityCreated,
  entityUpdated,
  userLoginStatus,
  userUid,
  microsite,
  entityLanguage,
  preferredEducationLevel,
  side_article
) => {
  if (window !== undefined && window?.dataLayer !== undefined) {
    window?.dataLayer?.push({
      contentType,
      pageType,
      domainId,
      verticalName,
      entityID,
      authorUid,
      authorName,
      entityCreated,
      entityUpdated,
      userLoginStatus,
      userUid,
      microsite,
      entityLanguage,
      preferredEducationLevel,
      side_article,
    });
  }
};

const clickLocation = new URLSearchParams(window.location.search)?.get("click_location") || '';
 //to check current url
 const subDomainName = window.location.host?.split(".")[0];
 const urlCheck = window.location.href;

 // to check the page is for certification domain
 let certificationFormCheck = window.location.search?.includes("ftype=certificationform") ||
  window.location.search?.includes("ftype=certification") || certificationPage(urlCheck);

const currentUrl = document.referrer || createCurrentUrl(); 
const ContentTypeData = getPageFromUrl(currentUrl)?.contentType || "";
export const gaLocationAndContentData = (clickLocation && ContentTypeData) ? `${clickLocation}_${ContentTypeData}` : clickLocation ? clickLocation : ContentTypeData ? ContentTypeData : "";
